'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/payment-pages/policy-information.js';
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _hero = require('@marmalade/bling/lib/hero');
var _hero2 = _interopRequireDefault(_hero);
var _secondaryCopy = require('@marmalade/bling/lib/order-status/secondary-copy');
var _secondaryCopy2 = _interopRequireDefault(_secondaryCopy);
var _definitionList = require('@marmalade/definition-list');
var _definitionList2 = _interopRequireDefault(_definitionList);
var _themes = require('@marmalade/themes');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _propTypes = require('prop-types');
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRouterDom = require('react-router-dom');
var _centrepointLogo = require('../../media/centrepoint-logo.png');
var _centrepointLogo2 = _interopRequireDefault(_centrepointLogo);
var _ldiSuccessImage = require('../../media/ldi-success-image.svg');
var _ldiSuccessImage2 = _interopRequireDefault(_ldiSuccessImage);
var _contentWrapper = require('./content-wrapper');
var _contentWrapper2 = _interopRequireDefault(_contentWrapper);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var _componentThemes$newB = _themes.componentThemes.newBusinessOrderStatus,
  orderStatusStyle = _componentThemes$newB.orderStatusStyle,
  orderStatusTheme = _componentThemes$newB.orderStatusTheme;
var imageWrapperStyles = function imageWrapperStyles(_ref) {
  var theme = _ref.theme;
  return _defineProperty({
    display: 'flex',
    flexBasis: '40%',
    padding: '0 ' + theme.space_lg,
    flexGrow: 1,
    alignItems: 'flex-start',
    maxWidth: 468
  }, (0, _themes.between)(0, theme.breakpoint_md), {
    padding: '0 3rem'
  });
};
var ImageWrapper = (0, _glamorous2.default)('div')(imageWrapperStyles);
var PolicyInformation = function (_Component) {
  _inherits(PolicyInformation, _Component);
  function PolicyInformation() {
    _classCallCheck(this, PolicyInformation);
    return _possibleConstructorReturn(this, (PolicyInformation.__proto__ || Object.getPrototypeOf(PolicyInformation)).apply(this, arguments));
  }
  _createClass(PolicyInformation, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        data = _props.data,
        theme = _props.theme,
        type = _props.type,
        hasDonated = _props.hasDonated;
      var isWhitelabel = theme.name !== 'Marmalade';
      return _react2.default.createElement(_contentWrapper2.default, {
        container: this.props.container,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 42
        },
        __self: this
      }, _react2.default.createElement(_hero2.default, {
        marginTop: '3rem',
        title: _react2.default.createElement(_react.Fragment, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 46
          },
          __self: this
        }, _react2.default.createElement(_glamorous.H2, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 47
          },
          __self: this
        }, 'You\'re all done'), _react2.default.createElement(_secondaryCopy2.default, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 48
          },
          __self: this
        }, 'Your insurance has been issued!')),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 43
        },
        __self: this
      }, _react2.default.createElement(_glamorous.Div, {
        flexBasis: orderStatusTheme(theme)[orderStatusStyle('image')] ? '60%' : undefined,
        paddingBottom: theme.space_md,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 52
        },
        __self: this
      }, _react2.default.createElement('div', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 56
        },
        __self: this
      }, _react2.default.createElement(_definitionList2.default, {
        offWhite: orderStatusTheme(theme)[orderStatusStyle('definitionListOffWhite')],
        headers: [{
          key: 'policyId',
          text: 'Policy number'
        }, {
          key: 'coverStartDate',
          text: 'Effective From'
        }],
        data: data,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 57
        },
        __self: this
      }), hasDonated ? _react2.default.createElement(LogoAndText, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 73
        },
        __self: this
      }, _react2.default.createElement('img', {
        src: _centrepointLogo2.default,
        alt: 'Centrepoint charity logo',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 74
        },
        __self: this
      }), _react2.default.createElement('p', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 75
        },
        __self: this
      }, 'Thank you for your payment, this includes your donation to Centrepoint. Your generosity and support is helping Centrepoint in their aim to end youth homelessness by 2037.')) : null, _react2.default.createElement(_glamorous.H3, {
        fontSize: '1.8rem',
        marginBottom: '.2rem',
        marginTop: '3rem',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 78
        },
        __self: this
      }, 'What happens now?'), type === 'RENEWAL' ? _react2.default.createElement('p', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 82
        },
        __self: this
      }, 'You can view or download your policy documents at any time during the term of the policy on the ', _react2.default.createElement(_reactRouterDom.Link, {
        to: '/account/dashboard',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 84
        },
        __self: this
      }, 'dashboard'), '. If you prefer, you can request paper copies of these documents, now or at any time during the policy term, by emailing ', _react2.default.createElement('a', {
        href: 'mailto:enquiries@marmalade.co.uk',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 84
        },
        __self: this
      }, 'enquiries@marmalade.co.uk'), '. No charge will be made for this.') : _react2.default.createElement('p', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 87
        },
        __self: this
      }, isWhitelabel ? 'Marmalade have emailed your login details to you' : 'Your login details have been emailed to you', '. After this you will receive an email with a link to your Marmalade account where you can view and download your policy documents. If you prefer, you can request paper copies of these documents, now or at any time during the policy term, by emailing ', _react2.default.createElement('a', {
        href: 'mailto:enquiries@marmalade.co.uk',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 92
        },
        __self: this
      }, 'enquiries@marmalade.co.uk'), '. No charge will be made for this.'))), orderStatusTheme(theme)[orderStatusStyle('image')] && _react2.default.createElement(ImageWrapper, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 98
        },
        __self: this
      }, _react2.default.createElement('img', {
        width: '100%',
        src: _ldiSuccessImage2.default,
        alt: 'Illustration of a yellow car with learner driver sat inside and L plates on besides tall city buildings',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 99
        },
        __self: this
      }))));
    }
  }]);
  return PolicyInformation;
}(_react.Component);
PolicyInformation.propTypes = {
  data: _propTypes.object.isRequired,
  theme: _propTypes.object.isRequired,
  container: _propTypes.bool.isRequired,
  type: _propTypes.string.isRequired,
  hasDonated: _propTypes.bool
};
exports.default = (0, _glamorous.withTheme)(PolicyInformation);
var LogoAndText = _glamorous2.default.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '16px',
  padding: '1em',
  border: '1px solid #D2D5D7',
  '@media screen and (min-width: 768px)': {
    flexDirection: 'row',
    marginBottom: '1em'
  }
});